<template>
  <div class="space-y-4">
    <div class="flex items-center justify-between">
      <div>
        <h3 class="text-lg font-semibold text-gray-900 dark:text-white">Marketplace</h3>
        <p class="mt-1 text-sm text-gray-500 dark:text-gray-400">
          Browse and install community tools from the marketplace
        </p>
      </div>
      <Button variant="primary" size="sm" @click="goToMarketplace">
        Open Marketplace
      </Button>
    </div>

    <!-- eslint-disable-next-line asab-design-system/no-raw-button-card-markup -- dashed empty-state box, not a Card (no dashed/empty variant exists yet) -->
    <div
      class="text-center py-16 bg-gray-50 dark:bg-gray-800/50 rounded-lg border-2 border-dashed border-gray-300 dark:border-gray-700"
    >
      <div class="space-y-3">
        <p class="text-gray-500 dark:text-gray-400 text-sm">
          Discover tools built by the community
        </p>
        <p class="text-gray-400 dark:text-gray-500 text-xs">
          Visit the marketplace to browse, install, and manage third-party tools
        </p>
        <Button variant="outline" size="sm" @click="goToMarketplace">
          Browse Tools
        </Button>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
  import { useRouter } from 'vue-router';
  import { Button } from '@asabdev/asab-ui';

  const router = useRouter();

  const goToMarketplace = () => {
    router.push('/app/marketplace');
  };
</script>
